import { FC, ReactNode } from 'react';
import { Box, Center, CenterProps, Icon, Stack, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';

export type StateMessageProps = CenterProps & {
  title: string;
  subtitle?: ReactNode;
  icon?: IconType;
};

export const StateMessage: FC<StateMessageProps> = ({
  title,
  subtitle,
  icon,
  ...props
}) => {
  return (
    <Center flex={1} {...props}>
      <Stack maxW="60%" spacing={4} align="center" textAlign="center">
        <Icon as={icon} fontSize="5xl" color="gray.300" />
        <Text fontSize="2xl" fontWeight="bold" data-testid="title">
          {title}
        </Text>
        <Box fontSize="lg" color="gray.600" data-testid="subtitle">
          {subtitle}
        </Box>
      </Stack>
    </Center>
  );
};
